import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { Highlight, useHits, useSearchBox } from 'react-instantsearch';
import { RecentSearches } from '@/app/baza/_components/Search/_components/SearchResult/RecentSearches';
import { saveRecentSearch } from '@/app/baza/_components/Search/_components/SearchResult/RecentSearches/recentSearchesStorage';
import { TopHits } from '@/app/baza/_components/Search/_components/SearchResult/TopHits';
import type { AlgoliaIndexItem } from '@/backend/modules/docs/external-functions/queries/algolia-index-item-type';
import { Link } from '@/frontend/design-system/actions/Link';
import { P2, P3 } from '@/frontend/design-system/typography/Paragraph';
export function SpecificCollectionSearchResult() {
  const $ = _c(25);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.split("/");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const segments = t0;
  const currentCollectionSlug = segments[2] ?? null;
  const {
    query
  } = useSearchBox();
  const {
    items: hits
  } = useHits();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== currentCollectionSlug || $[3] !== hits || $[4] !== query) {
    const q = query?.trim().toLowerCase() || "";
    const articleHits = hits.filter(hit => q && hit.article?.name.toLowerCase().includes(q));
    let t6;
    if ($[10] !== currentCollectionSlug) {
      t6 = hit_0 => hit_0.collection.slug === currentCollectionSlug;
      $[10] = currentCollectionSlug;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const inCurrentCollection = articleHits.filter(t6);
    let t7;
    if ($[12] !== currentCollectionSlug) {
      t7 = hit_1 => hit_1.collection.slug !== currentCollectionSlug;
      $[12] = currentCollectionSlug;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const otherArticles = articleHits.filter(t7);
    const hasHits = inCurrentCollection.length > 0 || otherArticles.length > 0;
    t1 = "flex w-full flex-col gap-6 py-6";
    if ($[14] !== query) {
      t2 = !query && <RecentSearches />;
      $[14] = query;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    if ($[16] !== hasHits || $[17] !== query) {
      t3 = query && !hasHits && <div className="flex flex-col gap-4"><P2 className="text-center text-contentInverseTertiary">Brak dopasowań dla "{query}"</P2><TopHits /></div>;
      $[16] = hasHits;
      $[17] = query;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    t4 = inCurrentCollection.length > 0 && <div><P2 className="font-semibold text-contentInverseSecondary">W tej kolekcji</P2><div className="mt-2 flex flex-col gap-3">{inCurrentCollection.map(_temp)}</div></div>;
    t5 = otherArticles.length > 0 && <div><P2 className="font-semibold text-contentInverseSecondary">Inne artykuły</P2><div className="mt-2 flex flex-col gap-3">{otherArticles.map(_temp2)}</div></div>;
    $[2] = currentCollectionSlug;
    $[3] = hits;
    $[4] = query;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}
function _temp2(hit_3) {
  return <Link key={hit_3.article.id} href={`/baza/${hit_3.collection.slug}/${hit_3.article.slug}`} className="group rounded-lg bg-backgroundSecondary px-3 py-3 hover:bg-backgroundBlue hover:text-contentBlue" onClick={() => saveRecentSearch(hit_3)}><P2 className="text-current"><Highlight hit={hit_3} attribute={["article", "name"]} classNames={{
        highlighted: "font-bold bg-transparent text-current"
      }} /></P2><P3 className="mt-1 text-contentInverseSecondary group-hover:text-contentBlue">{hit_3.collection.name}</P3></Link>;
}
function _temp(hit_2) {
  return <Link key={hit_2.article.id} href={`/baza/${hit_2.collection.slug}/${hit_2.article.slug}`} className="group rounded-lg bg-backgroundSecondary px-3 py-3 hover:bg-backgroundBlue hover:text-contentBlue" onClick={() => saveRecentSearch(hit_2)}><P2 className="text-current"><Highlight hit={hit_2} attribute={["article", "name"]} classNames={{
        highlighted: "font-bold bg-transparent text-current"
      }} /></P2><P3 className="mt-1 text-contentInverseSecondary group-hover:text-contentBlue">{hit_2.collection.name}</P3></Link>;
}